module.exports = __webpack_public_path__ + "img/61.7.Chla.9deca417.png";